<div class="page-container">
	<div class="grid-container">
		<tlk-banner *ngIf="isSendToIDSMessageVisible$ | async" class="grid-item grid-item-full" [type]="'info'">
			<span tlkBannerBody>{{ 'OrderSection.StudyModelsAreAvailableForInvisalignMessage' | translate }}</span>
		</tlk-banner>
		<rx-intuitive-art-banners-orchestrator
			*ngIf="(isArtProcedureSelected$ | async) && !(isReadOnly$ | async)"
			[attachmentsListUpdated$]="intuitiveAttachments.attachmentsListUpdated"
			class="grid-item grid-item-full"
		></rx-intuitive-art-banners-orchestrator>
		<rx-intuitive-order class="grid-item grid-item-full"></rx-intuitive-order>
		<rx-intuitive-appliance-details
			*ngIf="isApplianceProcedureSectionVisible$ | async"
			class="grid-item grid-item-full"
		></rx-intuitive-appliance-details>
		<rx-intuitive-invisalign-details
			*ngIf="isInvisalignDetailsVisible$ | async"
			class="grid-item grid-item-full"
		></rx-intuitive-invisalign-details>
		<rx-intuitive-scan-surgical-guide
			*ngIf="isScanSurgicalGuideSectionVisible$ | async"
			class="grid-item grid-item-full"
		></rx-intuitive-scan-surgical-guide>
		<rx-intuitive-denture-procedure
			*ngIf="isDentureDetailsVisible$ | async"
			class="grid-item grid-item-full"
		></rx-intuitive-denture-procedure>
		<rx-intuitive-arch-alignment
			*ngIf="isArtProcedureSelected$ | async"
			class="grid-item grid-item-full"
		></rx-intuitive-arch-alignment>
		<rx-intuitive-teeth-orchestrator-container
			*ngIf="isToothDiagramVisible$ | async"
			class="grid-item grid-item-full"
		></rx-intuitive-teeth-orchestrator-container>
		<rx-intuitive-scan-options class="grid-item grid-item-full"></rx-intuitive-scan-options>
		<div
			class="grid-item grid-item-full attachments-notes-row"
			[class.attachments-notes-row--read-only-both-fill]="attachmentsNotesReadOnlyBothFillRow$ | async"
		>
			<rx-intuitive-attachments #intuitiveAttachments />
			<rx-intuitive-notes *ngIf="isNotesVisible$ | async" />
		</div>

		<!-- Additional Content Placeholder -->
		<ng-content></ng-content>
	</div>
</div>
